import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text } from '@chakra-ui/react';

function HighlightedText({ words, sentence, paragraph }) {
  // Split the paragraph into parts: before, matched sentence, and after
  const [before, after] = paragraph.split(sentence);

  // Split the sentence into parts to highlight the words
  const sentenceParts = sentence.split(new RegExp(`(${words})`, 'g'));

  return (
    <Box>
      <Text as="span">{before}</Text>
      <Text as="span" bg="gray.100" px={1} borderRadius="md">
        {sentenceParts.map((part, index) =>
          part === words ? (
            <Text as="span" fontWeight="bold" key={index}>
              {part}
            </Text>
          ) : (
            <Text as="span" key={index}>
              {part}
            </Text>
          )
        )}
      </Text>
      <Text as="span">{after}</Text>
    </Box>
  );
}

HighlightedText.propTypes = {
  words: PropTypes.string.isRequired,
  sentence: PropTypes.string.isRequired,
  paragraph: PropTypes.string.isRequired,
};

export default HighlightedText;
